module.exports = __webpack_public_path__ + "img/Mobile_home_img2.520838ca.png";